<style lang="less" scoped>
.form-contain {
    .sub-child-contain {
        padding: 10px;
        border: 1px solid rgba(0,0,0,.25);
        border-radius: 5px;
        margin-bottom: 10px;
    }
    .flex-contain {
      display: flex;
      align-items: center;
    }
}
</style>
<template>
  <div>
    <v-btn
      color="primary"
      dark
      small
      style="margin-bottom:10px"
      @click="addNewOne"
    >
      增加
    </v-btn>
    <v-form
      ref="form"
      :value="true"
      class="form-contain"
      style="width: 100%;"
    >
      <div
        v-for="(data_arr_item,subChildIndex) in data_arr"
        :key="subChildIndex"
        class="sub-child-contain"
      >
        <v-row>
          <v-col
            cols="12"
          >
            <span>HC条目-{{ subChildIndex+1 }}</span>
          </v-col>
          <v-col
            v-show="data_arr.length!==1"
            cols="12"
          >
            <v-menu
              v-model="data_arr_item.show_ddelet_m_menus"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  删除
                </v-btn>
              </template>

              <v-card>
                <v-card-title>提示</v-card-title>
                <v-card-text>
                  确定删除该条目？
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    @click="data_arr_item.show_ddelet_m_menus = false"
                  >
                    取消
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="data_arr.splice(subChildIndex,1)"
                  >
                    确定
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-col> 
          <v-col
            cols="4"
          >
            <v-text-field
              v-model="data_arr_item.headcount_total"
              label="申请HC个数*"
              type="number"
              required
              :rules="rules.headcount_total"
            />
          </v-col>   
          <v-col
            cols="4"
          >
            <v-select
              v-model="data_arr_item.headcount_type"
              label="申请HC类型*"
              :items="customer_types"
              item-value="value"
              :item-text="({label}={})=>label"
              required
              :rules="rules.headcount_type"
            />
          </v-col>   
          <v-col
            cols="4"
          >
            <v-text-field
              v-model="data_arr_item.sequence_name"
              label="申请序列"
            />
          </v-col> 
          <v-col cols="12">
            <DynamicForm
              ref="tableForm"
              v-model="data_arr_item.table_data"
              :start-date="parentDetail.quarter_start_at"
            />
          </v-col>
        </v-row>
      </div>
    </v-form>    
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import DynamicForm from './DynamicForm'
  import { integer, nonNull, initSub } from '../utils'
  export default {
    components: {
      DynamicForm
    },
    props: {
      value:{
        type: Array
      },
      parentDetail: {
        type: Object
      }
    },
    data() {
      return {
        data_arr: this.value
      }
    },
    methods: {
      validate() {
        const arr = [...this.$refs.tableForm, this.$refs.form]
        return arr.map(item => item.validate()).every(validate => validate)
      },
      refresh() {
        this.$refs.form.resetValidation()
        const tableForm = this.$refs.tableForm || []
        tableForm.forEach(item => {
          item && item.resetValidation()
        })
      },
      addNewOne() {
        this.data_arr.push(initSub())
      }
    },
    computed: {
      ...mapGetters('async', {
        analysis_leaf_titles: 'analysis_leaf_titles', // 分析
        customer_types: 'customer_types',
        analysis_leaf_titles_hash: 'analysis_leaf_titles_hash'
      }),
      rules() {
        return {
          headcount_total: [
            nonNull('申请HC个数必填'),
            integer
          ],
          headcount_type: [
            nonNull('申请HC类型必选')
          ],
        }
      },
    },
    watch: {
      watch: {
        data_arr(data) {
          this.$emit('input', data)
        },
        value(data) {
          this.data_arr = data
        }
      },
    },
  }
</script>